module.exports = __webpack_public_path__ + "img/icon-83.eeb2b94f.png";